export const ROUTES = {
  AUTHENTICATE: '/authenticate',
  PENDING_ACCESS: '/pending-access',
  REGION: '/region/:region',
  APP: '/region/:region/season/:season',
  SEASON_SCOPE: 'season/:season',
  FIELD_ALLOCATION: 'field-allocation',
  PRODUCTION_PROGRESS: 'production-progress',
  SEASONS_MANAGEMENT: 'seasons-management',
  GROWER_LIST: 'growers',
  GROWING_SUBGROWING_AREAS: 'growing-subgrowing-areas',
  GROWER: 'growers/:growerId',
  GROWER_PROPERTY: 'growers/:growerId/properties/:propertyId',
  CYCLE_FIELDS: 'cycle-fields',
  CYCLE_FIELDS_ADD: 'cycle-fields/add-fields',
  PRODUCTION_ORDER_LIST: 'production-orders',
  VARIETY_DEVIATION: 'variety-deviation',
  WORKER_LIST: 'workers',
  PARENT_SEED_ATTRIBUTE_LIST: 'parent-seed-attributes',
  PARENT_SEEDS_ASSIGNMENT: 'parent-seeds-assignment',
  AGRONOMIC_DEMAND: 'agronomic-demand',
  EXPORT_BATCHES: 'batches-export',
  PRODUCTION_INSTRUCTIONS: 'production-instructions',
  PRODUCTION_INSTRUCTIONS_TEMPLATE: 'production-instructions-template',
  DATA_IMPORT: 'data-import',
  REVIEW_SPP_DATA: 'review-spp-data',
  CROPWISE_INTEGRATIONS: 'cropwise-integrations'
};
